import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnabledAuthMethod } from '@shared/models/settings/enabled-auth-method';
import { SignSignatory } from '@shared/models/signrequest/sign.signatory';

import { CommonModule } from '@angular/common';
import { AuthMethodsIndicatorComponent } from '../../auth-methods-indicator/auth-methods-indicator.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-sr-recipient',
    templateUrl: './sr-recipient.component.html',
    styleUrls: ['./sr-recipient.component.scss'],
    standalone: true,
    imports: [CommonModule, AuthMethodsIndicatorComponent, TranslateModule]
})
export class SrRecipientComponent {
    @Input() recipient!: SignSignatory;
    @Input() selected!: boolean;
    @Input() enabledAuthMethods!: EnabledAuthMethod[];
    @Output() selectedRecipient: EventEmitter<SignSignatory> = new EventEmitter<SignSignatory>();

    toggleSignatoryDetails(signatory: SignSignatory) {
        this.selectedRecipient.emit(signatory);
    }
}
